<template>
  <div>
    <top-page />
    <div class="space-gutter"></div>
    <about-page />
    <experiencePage />
    <projects-page />
    <contact-page />
  </div>
</template>

<script>
import topPage from "../components/topPage";
import aboutPage from "../components/aboutPage";
import projectsPage from "../components/projectsPage";
import experiencePage from "../components/experiencePage";
import contactPage from "../components/contactPage";

export default {
  name: "App",
  components: {
    topPage,
    aboutPage,
    projectsPage,
    contactPage,
    experiencePage,
  },
};
</script>

<style lang="scss" scoped>
.space-gutter {
  min-height: 100px;
  height: 15vh;
  max-height: 500px;
  background-color: #f1f1f1;
}
</style>